import { GET_SUB_DOMAINS } from '@/services/api/setting/personalization/domainManagement'
import { Helper } from '@/mixin/helper'
import store from '@/state/store'

const isParent = store.getters['identity/isParent'](isParent)

export const tableFilterFieldsFleetUtilization = [
  {
    name: 'created_on',
    isShow: true,
  },
]

export function getTableFilterFields() {
  return [
    {
      name: 'created_on',
      isShow: true,
      label: this.$t('report.object.reportPeriod'),
      placeholder: this.$t('global.action.selectMonth'),
      _label: null,
      type: 'date-picker',
      datepickerType: 'month',
      valueType: 'YYYY-MM',
      format: 'MMM YYYY',
      titleFormat: 'MMM YYYY',
      rangeSeparator: ' - ',
      range: false,
      confirm: false,
      confirmText: this.$t('global.action.apply'),
      clearable: false,
      hasTooltip: false,
      isRequired: true,
      disabledDate: (date) => {
        const currentDate = new Date()
        const dateToCheck = new Date(date)
        return (
          dateToCheck.getFullYear() > currentDate.getFullYear() ||
          (dateToCheck.getFullYear() === currentDate.getFullYear() &&
            dateToCheck.getMonth() > currentDate.getMonth())
        )
      },
    },
    {
      name: 'company_id',
      isShow:
        store.getters['identity/hasAccess'](['a10e-report-child-monitoring:read']) &&
        store.getters['identity/isParent'] &&
        isParent,
      label: this.$t('setting.list.managementAsset.subdomain.domain'),
      type: 'value-help-v2',
      placeholder: `${this.$t('global.form.select')} ${this.$t(
        'setting.list.managementAsset.subdomain.domain'
      )}`,
      trackBy: 'companyId',
      displayedBy: 'companyName',
      listGetter: fetchSubDomains.bind(this),
      multiple: true,
      tableFields: [
        {
          label: this.$t('setting.list.managementAsset.subdomain.companyName'),
          key: 'companyName',
          isSortable: false,
        },
        {
          label: this.$t('setting.list.managementAsset.subdomain.domainName'),
          key: 'domainName',
          isSortable: false,
        },
      ],
      hasTooltip: false,
      isRequired: true,
    },
  ]
}

async function fetchSubDomains(opts) {
  const searchValue = opts && opts.search ? opts.search : ''
  const filter = {
    orderBy: [JSON.stringify({ name: 'asc' })],
    search: searchValue,
    includeParent: true,
  }
  const res = await this.$apollo.query({
    fetchPolicy: 'no-cache',
    query: GET_SUB_DOMAINS,
    variables: {
      filter: filter,
    },
  })

  const domainManagements = res.data.domainManagements.domainManagements
  const pagination = domainManagements.pagination

  const mappedData = domainManagements.data.map((domain) => ({
    companyId: domain.companyId,
    companyName: domain.companyName,
    domainName: domain.domainName,
  }))

  const companyIndex = mappedData.findIndex(
    (item) => item.companyId === Helper.methods.getCompanyId()
  )

  if (companyIndex !== -1) {
    const companyItem = mappedData.splice(companyIndex, 1)[0]
    mappedData.unshift(companyItem)
  }

  const result = {
    status: true,
    message: 'Success Get Data',
    data: {
      paginated_result: mappedData,
      ids: mappedData.map((domain) => domain.companyId),
    },
    metadata: {
      count: pagination.show,
      page: pagination.page,
      total_page: Math.ceil(pagination.total / pagination.show),
      total_count: pagination.total,
    },
  }

  return result
}
